/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Qa as Qa,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
} from "../../runtime/index.jsx";
export function FotoIncidencia(e) {
  let t = (0, ReactCompiler.c)(11),
    { incidenciaId: n, foto: r } = e,
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(!1),
    c,
    l;
  if (
    (t[0] !== r.id || t[1] !== n
      ? ((c = () => {
          let e = !0,
            t = null,
            i = `/incidencias/${n}/fotos/${r.id}`;
          return (
            (async function () {
              let n = await api(`${i}/enlace`, {
                sinCache: !0,
              });
              if (n?.remoto) {
                e && a(n.url);
                return;
              }
              let r = await Qa(i);
              ((t = r), e ? a(r) : URL.revokeObjectURL(r));
            })().catch(() => {
              e && s(!0);
            }),
            () => {
              ((e = !1), t && URL.revokeObjectURL(t));
            }
          );
        }),
        (l = [n, r.id]),
        (t[0] = r.id),
        (t[1] = n),
        (t[2] = c),
        (t[3] = l))
      : ((c = t[2]), (l = t[3])),
    (0, React.useEffect)(c, l),
    o)
  ) {
    let e;
    return (
      t[4] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <p
              className={`text-xs text-(--text)`}
              children={`No se pudo abrir la foto`}
            />
          )),
          (t[4] = e))
        : (e = t[4]),
      e
    );
  }
  if (!i) {
    let e;
    return (
      t[5] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <div className={`h-32 animate-pulse rounded-xl bg-(--border)`} />
          )),
          (t[5] = e))
        : (e = t[5]),
      e
    );
  }
  let u;
  t[6] === i
    ? (u = t[7])
    : ((u = (
        <img
          src={i}
          alt={`Lo que se encontró`}
          className={`h-32 w-full rounded-xl border border-(--border) object-contain`}
        />
      )),
      (t[6] = i),
      (t[7] = u));
  let f;
  return (
    t[8] !== u || t[9] !== i
      ? ((f = <a href={i} target={`_blank`} rel={`noreferrer`} children={u} />),
        (t[8] = u),
        (t[9] = i),
        (t[10] = f))
      : (f = t[10]),
    f
  );
}
